import {
  ExtratoSaldoContaService,
  PercentualRecebimentoRendaService,
  TransformacaoBeneficioService,
} from '@services';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import { getExtratoContaSuccess } from './actions';
import { hideLoad, showLoad } from '../loading/actions';

function* recuperaExtratoContaParticipante() {
  const service = new ExtratoSaldoContaService();
  const percentualRecebimentoService = new PercentualRecebimentoRendaService();
  const transformacaoBeneficioService = new TransformacaoBeneficioService();
  const user = yield select((state) => state.user);
  yield put(showLoad());

  const extratoContas = yield service.getExtratoSaldoContaParticipante(
    user.matricula,
    user.plano,
    user.corteExtrato[1] + user.corteExtrato[0]
  );

  const retiradaParticipante =
    yield percentualRecebimentoService.getRecebimentoSaldoContas(
      user.matricula,
      user.plano
    );

  const retiradaParticipanteFormatada = Number(
    retiradaParticipante.replace(',', '.')
  );

  const farolLimites =
    yield transformacaoBeneficioService.getLimitesSaudeFinanceira();

  const farolLabel = farolLimites.filter(
    (item) =>
      retiradaParticipanteFormatada >= item.Minimo &&
      retiradaParticipanteFormatada <= item.Maximo
  )[0].Farol;

  const exaurimento = yield transformacaoBeneficioService.getCalculoExaurimento(
    {
      matricula: user.matricula,
      dataNascimento: user.dadosPessoais.nascimento
        .split('/')
        .reverse()
        .join('-'),
      parcelaAdicional: 1,
      saldo: extratoContas.saldo,
      saqueVista: 0,
      inflacao: 4,
      renda: extratoContas.saldo * (retiradaParticipanteFormatada / 100),
      plano: user.plano,
    }
  );

  const saudeFinanceira = {
    farol: farolLabel,
    percentualRetirada: retiradaParticipanteFormatada,
    exaurimento,
  };

  const objRetorno = {
    ContaAdicional: extratoContas.ContaAdicional,
    ContaIndividual: extratoContas.ContaIndividual,
    ContaPatronal: extratoContas.ContaPatronal,
    Saldo: extratoContas.saldo,
    Rentabilidade: extratoContas.rentabilidade,
    ultimaRentabilidade: extratoContas.ultimaRentabilidade,
    saudeFinanceira,
  };

  yield put(getExtratoContaSuccess(objRetorno));
  yield put(hideLoad());
}

export default all([
  takeLatest('EXTRATO_CONTA_REQUEST', recuperaExtratoContaParticipante),
]);
